import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PrinterAliasDialogData {
  currentAlias: string;
}

@Component({
  selector: 'app-printer-alias-dialog',
  template: `
    <h2 mat-dialog-title>{{ 'Printers.set_alias' | transloco }}</h2>

    <div mat-dialog-content class="flex flex-col gap-4">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ 'name' | transloco }}</mat-label>
        <input matInput [formControl]="aliasCtrl" [placeholder]="'Printers.enter_alias' | transloco" />
      </mat-form-field>
    </div>

    <div mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">{{ 'cancel' | transloco }}</button>
      <button mat-flat-button color="primary" (click)="onSave()">{{ 'save' | transloco }}</button>
    </div>
  `
})
export class PrinterAliasDialogComponent {
  aliasCtrl = new FormControl('');

  constructor(
    private dialogRef: MatDialogRef<PrinterAliasDialogComponent, string | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: PrinterAliasDialogData
  ) {
    this.aliasCtrl.setValue(data?.currentAlias ?? '');
  }

  onCancel(): void {
    this.dialogRef.close(undefined);
  }

  onSave(): void {
    const value = (this.aliasCtrl.value ?? '').toString();
    this.dialogRef.close(value);
  }
}
